/**
 * @generated SignedSource<<b9b8ffbb7a8a95130ac3f67aa18cd32e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type missedCallAgendaAppointmentDrawerDataFragment$data = {
  readonly id: string;
  readonly missedCalls: ReadonlyArray<string>;
  readonly " $fragmentType": "missedCallAgendaAppointmentDrawerDataFragment";
};
export type missedCallAgendaAppointmentDrawerDataFragment$key = {
  readonly " $data"?: missedCallAgendaAppointmentDrawerDataFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"missedCallAgendaAppointmentDrawerDataFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "missedCallAgendaAppointmentDrawerDataFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "missedCalls",
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};

(node as any).hash = "89a645f67a6fc342170fc4906c69e391";

export default node;
